import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../../config/api';
import { addAccounts } from '../../../features/createBudget/createBudgetSlice';

export const useAccount = ({
  dataPaginationAccountTab,
  pageSize,
  debouncedSearchTerm,
  setSearchResults,
}) => {
  const dispatch = useDispatch();

  const { choosenSources, setCampaignsTab, isProcessSyncDataSource } =
    useSelector(state => state.createBudget);

  const [isLoading, setIsLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    const fetchAccountData = async () => {
      const isFetchingAccountData = setCampaignsTab === 'campaigns';
      if (isFetchingAccountData) return;

      setIsLoading(true);
      const idDataSource = choosenSources.length ? choosenSources[0].id : '';

      try {
        const res = await api.GET_ACCOUNTS(idDataSource, {
          page: dataPaginationAccountTab.currentPage,
          size: pageSize.value,
          search: debouncedSearchTerm,
        });

        const { results, count } = res;
        setTotalItems(count);

        const data = results.map(el => ({
          ...el,
          ...(idDataSource ? { data_source_id: idDataSource } : {}),
        }));

        setSearchResults(data);
        dispatch(addAccounts(data));
      } catch (error) {
        console.log({ error });
      } finally {
        setIsLoading(false);
      }
    };
    fetchAccountData();
  }, [
    choosenSources,
    dataPaginationAccountTab.currentPage,
    dataPaginationAccountTab.totalItems,
    setCampaignsTab,
    debouncedSearchTerm,
    isProcessSyncDataSource,
    pageSize.value,
    setSearchResults,
    dispatch,
  ]);

  return {
    isLoading,
    totalItems,
  };
};
